<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Logo Color and Grayscale</b-card-title>
      </b-card-header>
      <b-card-body class="pb-1">
        <b-card-text>
          <p>
            EasyParcel logo is available in two color schemes: pink and white.
            <br>
            The pink version works best on a white or light background. The white version should be used on pink or dark backgrounds.
            <br>
            The grayscale version of the logo is for use in black and white documents.
          </p>
          <p>Avoid using EasyParcel logo on photographs unless the logo sits on an empty areas of image.</p>
        </b-card-text>
        <div class="table-responsive-sm">
          <table class="table b-table">
            <thead>
              <tr>
                <th class="text-center">
                  White logo
                </th>
                <th class="text-center">
                  Pink logo
                </th>
                <th class="text-center">
                  Light logo
                </th>
                <th class="text-center">
                  Dark logo
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="bg-primary">
                  <b-img
                    :src="require('@/assets/images/logo/horizontal-logo-white.svg')"
                    class="w-100"
                    alt="EasyParcel Horizontal Logo White"
                  />
                </td>
                <td :class="isDark ? 'bg-light' : 'bg-white'">
                  <b-img
                    :src="require('@/assets/images/logo/horizontal-logo-pink.svg')"
                    class="w-100"
                    alt="EasyParcel Horizontal Logo Pink"
                  />
                </td>
                <td class="bg-black">
                  <b-img
                    :src="require('@/assets/images/logo/horizontal-logo-white.svg')"
                    class="w-100"
                    alt="EasyParcel Horizontal Logo Light"
                  />
                </td>
                <td :class="isDark ? 'bg-light' : 'bg-white'">
                  <b-img
                    :src="require('@/assets/images/logo/horizontal-logo-dark.svg')"
                    class="w-100"
                    alt="EasyParcel Horizontal Logo Dark"
                  />
                </td>
              </tr>
              <tr>
                <td class="bg-primary">
                  <b-img
                    :src="require('@/assets/images/logo/vertical-logo-white.svg')"
                    class="w-100"
                    alt="EasyParcel Vertical Logo White"
                  />
                </td>
                <td :class="isDark ? 'bg-light' : 'bg-white'">
                  <b-img
                    :src="require('@/assets/images/logo/vertical-logo-pink.svg')"
                    class="w-100"
                    alt="EasyParcel Vertical Logo Pink"
                  />
                </td>
                <td class="bg-black">
                  <b-img
                    :src="require('@/assets/images/logo/vertical-logo-white.svg')"
                    class="w-100"
                    alt="EasyParcel Vertical Logo Light"
                  />
                </td>
                <td :class="isDark ? 'bg-light' : 'bg-white'">
                  <b-img
                    :src="require('@/assets/images/logo/vertical-logo-dark.svg')"
                    class="w-100"
                    alt="EasyParcel Vertical Logo Dark"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import {
  BCard, BImg, BCardHeader, BCardTitle, BCardBody, BCardText,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    // BRow,
    // BCol,
    BImg,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardText,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { skin } = useAppConfig()
    const isDark = computed(() => skin.value === 'dark')
    return { skin, isDark }
  },
}
</script>
